import { Banco } from "./banco";
import { TipoTarjeta } from "./tipo-tarjeta";
import { FormaPago } from "./forma-pago";

export class PagoDetalle{
    public constructor(
        public fecha_cheque: String = "",
        public numero_cta: String = "",
        public numero_cheque: String = "",
        public banco_id: String = "",
        public observacion: String = "",
        public debito_credito: String = "",
        public tipo_tarjeta_id: String = "",
        public plazo: number = 0,
        public tiempo: String = "dias",
        public valor: number = 0,
        public empresa_id: String = "",
        public sucursal_id: String = "",
        public pago_id: String = "",
        public forma_pago_id: String = "",
        public usuario_id: String = null,

        public fecha_transferencia: String = "",
        public numero_comprobante: String = "",

        public banco: Banco = new Banco(),
        public tipotarjeta: TipoTarjeta = new TipoTarjeta(),
        public formapago: FormaPago = new FormaPago(),
    ){}
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/pago_detalle.ts